module.exports = __webpack_public_path__ + "img/002-room.67cf496b.svg";